/* eslint-disable */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderITOfficerPage from "../RenderITOfficerPage";
import UploadCard from "../components/UploadCard";

/**
 * UPNMG staff loan deductions. Same sheet format as UploadLoans — the backend
 * tags these rows member_type='STAFF' so they stay out of the member figures.
 */
function UploadStaffLoans() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleUpload = async (file) => {
    setIsLoading(true);
    setResponse(null);
    try {
      const formData = new FormData();
      formData.append("file", file);
      await axiosInstance.post("/loans/staff/upload", formData);
      setResponse({ state: "SUCCESS", message: "Staff loan deductions uploaded successfully. Processing in background." });
      toast.success("Staff loan deductions uploaded successfully");
    } catch (e) {
      const msg = e?.response?.data?.message ?? "Upload failed. Try again.";
      setResponse({ state: "ERROR", message: msg });
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderITOfficerPage title="Upload Staff Loans">
      <UploadCard
        title="Upload Staff Loan Deductions"
        description="Upload an Excel or CSV file of loan deductions for UPNMG staff. Same columns as the member sheet — these records are kept separate from member deductions."
        onUpload={handleUpload}
        isLoading={isLoading}
        response={response}
        accentColor="blue"
      />
      <ToastContainer autoClose={3000} />
    </RenderITOfficerPage>
  );
}

export default UploadStaffLoans;
